import React from 'react';
import MediaLibraryProvider from 'containers/MediaLibrary/MediaLibraryProvider';
import FileSelector from 'components/MediaLibrary/FileSelector';

const FileSelectorContainer = props => (
  <MediaLibraryProvider>
    <FileSelector {...props} />
  </MediaLibraryProvider>
);

export default FileSelectorContainer;



// WEBPACK FOOTER //
// ./src/js/containers/MediaLibrary/FileSelectorContainer.js